import { Link } from "react-router-dom";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { LOGO, CONTACT } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer className="bg-chocolate text-cream/80 pt-16 pb-8 px-5 sm:px-8">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3">
          <img src={LOGO} alt="Logo Moum's" className="h-16 w-16 object-contain" />
          <span className="font-heading text-2xl font-semibold text-cream">Moum's</span>
        </div>
        <p className="mt-4 max-w-md leading-relaxed">
          Prestataire de glace à l'italienne pour tous vos événements dans toute l'Île-de-France.
          La gourmandise qui fait fondre vos événements. 🍦
        </p>
        <div className="flex gap-3 mt-5">
          <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-10 w-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-strawberry transition"><FaInstagram className="text-cream" /></a>
          <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="h-10 w-10 rounded-full bg-cream/10 flex items-center justify-center hover:bg-strawberry transition"><FaFacebookF className="text-cream" /></a>
        </div>
      </div>

      <div>
        <h4 className="font-heading text-lg font-semibold text-cream mb-4">Navigation</h4>
        <ul className="space-y-2 text-sm">
          {["prestations","parfums","toppings","galerie","faq","contact"].map((id) => (
            <li key={id}><button onClick={() => scrollToId(id)} className="hover:text-cream capitalize transition">{id === "toppings" ? "Toppings & Coulis" : id}</button></li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-heading text-lg font-semibold text-cream mb-4">Contact</h4>
        <ul className="space-y-2 text-sm">
          <li><a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-cream">{CONTACT.phone}</a></li>
          <li><a href={`mailto:${CONTACT.email}`} className="hover:text-cream">{CONTACT.email}</a></li>
          <li>{CONTACT.zone}</li>
        </ul>
      </div>
    </div>

    <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-cream/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/60">
      <p>© {new Date().getFullYear()} Moum's — Tous droits réservés.</p>
      <div className="flex gap-5">
        <Link to="/mentions-legales" className="hover:text-cream">Mentions légales</Link>
        <Link to="/politique-confidentialite" className="hover:text-cream">Politique de confidentialité</Link>
      </div>
    </div>
  </footer>
);
